import React from 'react'
const DisplayCoin = ({coinCode}) => {

let coins = {
    EUR: "€",
    USD: "$",
    GBP: "£",
    SEK: "kr",
    CHF: "CHF",
    MXN: "$",
    BRL: "R$",
    AUD: "A$",
    NOK: "kr",
    SGD: "S$",
    ZAR: "R",
    AED: "د.إ",
    TRY: "₺",
    CAD: "C$",
    JPY: "¥",
    ILS: "₪",
    DKK: "kr",
    NZD: "NZ$",
    PLN: "zł",
    MYR: "RM",
    DOP: "RD$"
};

    return (
        <span className="coin">
            {coins[coinCode] ? coins[coinCode] : coinCode}
        </span>      
    )
}

export default DisplayCoin
